/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { WebApiCustomListsDtoCustomListItemDto } from './WebApiCustomListsDtoCustomListItemDto';
import {
    WebApiCustomListsDtoCustomListItemDtoFromJSON,
    WebApiCustomListsDtoCustomListItemDtoFromJSONTyped,
    WebApiCustomListsDtoCustomListItemDtoToJSON,
} from './WebApiCustomListsDtoCustomListItemDto';
import type { WebApiModelsEnumerationTypesCustomListType } from './WebApiModelsEnumerationTypesCustomListType';
import {
    WebApiModelsEnumerationTypesCustomListTypeFromJSON,
    WebApiModelsEnumerationTypesCustomListTypeFromJSONTyped,
    WebApiModelsEnumerationTypesCustomListTypeToJSON,
} from './WebApiModelsEnumerationTypesCustomListType';

/**
 * 
 * @export
 * @interface WebApiMemberDtoCustomListConnectionDto
 */
export interface WebApiMemberDtoCustomListConnectionDto {
    /**
     * 
     * @type {number}
     * @memberof WebApiMemberDtoCustomListConnectionDto
     */
    memberFieldId?: number;
    /**
     * 
     * @type {number}
     * @memberof WebApiMemberDtoCustomListConnectionDto
     */
    customListId?: number;
    /**
     * 
     * @type {WebApiModelsEnumerationTypesCustomListType}
     * @memberof WebApiMemberDtoCustomListConnectionDto
     */
    customListType?: WebApiModelsEnumerationTypesCustomListType;
    /**
     * 
     * @type {number}
     * @memberof WebApiMemberDtoCustomListConnectionDto
     */
    customListItemId?: number;
    /**
     * 
     * @type {WebApiCustomListsDtoCustomListItemDto}
     * @memberof WebApiMemberDtoCustomListConnectionDto
     */
    item?: WebApiCustomListsDtoCustomListItemDto;
}

/**
 * Check if a given object implements the WebApiMemberDtoCustomListConnectionDto interface.
 */
export function instanceOfWebApiMemberDtoCustomListConnectionDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function WebApiMemberDtoCustomListConnectionDtoFromJSON(json: any): WebApiMemberDtoCustomListConnectionDto {
    return WebApiMemberDtoCustomListConnectionDtoFromJSONTyped(json, false);
}

export function WebApiMemberDtoCustomListConnectionDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): WebApiMemberDtoCustomListConnectionDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'memberFieldId': !exists(json, 'memberFieldId') ? undefined : json['memberFieldId'],
        'customListId': !exists(json, 'customListId') ? undefined : json['customListId'],
        'customListType': !exists(json, 'customListType') ? undefined : WebApiModelsEnumerationTypesCustomListTypeFromJSON(json['customListType']),
        'customListItemId': !exists(json, 'customListItemId') ? undefined : json['customListItemId'],
        'item': !exists(json, 'item') ? undefined : WebApiCustomListsDtoCustomListItemDtoFromJSON(json['item']),
    };
}

export function WebApiMemberDtoCustomListConnectionDtoToJSON(value?: WebApiMemberDtoCustomListConnectionDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'memberFieldId': value.memberFieldId,
        'customListId': value.customListId,
        'customListType': WebApiModelsEnumerationTypesCustomListTypeToJSON(value.customListType),
        'customListItemId': value.customListItemId,
        'item': WebApiCustomListsDtoCustomListItemDtoToJSON(value.item),
    };
}

